import propTypes from 'prop-types';
import React from 'react';
import * as theme from '../constants/theme';
import {MainMenuItem} from '.';

const {BACKGROUND, GUTTER, LARGE_FONT, TEXT_WHITE} = theme;

const MainMenu = ({items, open, ...props}) => {
	return (
		<nav role='navigation' className={'MainMenu ' + (open ? 'is-open' : 'is-closed')} {...props}>
			<ul>
				{items.map(x => (
					<MainMenuItem
						key={x.id}
						title={x.title}
						url={x.url}
					/>
				))}
			</ul>
			<style jsx>
				{`
					nav {
						top: 110px;
						left: 0;
						position: fixed;
						z-index: 99;
						width: 100%;
						height: 100%;
						background: ${BACKGROUND};
						color: ${TEXT_WHITE};
						font-size: ${LARGE_FONT};
						max-height: 0;
						transition: all .4s ease-out;
						overflow: hidden;
					}

					nav ul {
						max-width: 1280px;
						margin: 0 auto;
						padding-top: ${GUTTER};
						position: absolute;
						left: 0;
						right: 0;
						visibility: hidden;
					}

					nav.is-open {
						max-height: 100%;
					}

					nav.is-open > ul {
						visibility: visible;
					}
				`}
			</style>
		</nav>
	);
};

MainMenu.propTypes = {
	items: propTypes.array,
	open: propTypes.bool
};

MainMenu.defaultProps = {
	items: []
};

export default MainMenu;



// WEBPACK FOOTER //
// components/main-menu.js